import React from 'react'
import ThemeSwitcher from '../components/ThemeSwitcher'
import PropTypes from 'prop-types'
import { Link, graphql, Img } from 'gatsby'
const Header = ({ children }) => (
      <div className="page-header">
        <div className="header-item-one">
          <div className="page-header-text">{children}</div>
        </div>
        <div className="header-item-two">
          <div className="page-header-color" id="page-header-color"><ThemeSwitcher /></div>
        </div>
      </div>
)

export default Header